import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FinanceLedgersLayout } from '@mews-commander/modules/src/modules/finance';
import { ErrorHandler } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Ledgers')({
    loader: ({ context: { checkPrivilege } }) => {
        checkPrivilege('viewSensitiveReports');
    },
    component: () => (
        <FinanceLedgersLayout>
            <Outlet />
        </FinanceLedgersLayout>
    ),
    // TODO: should be replaced with global not found handler
    notFoundComponent: () => <NotFoundComponent />,
    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Frontend,
        title: TextKey.Ledgers,
        excludeBreadcrumb: true,
    },
});

const NotFoundComponent = () => (
    <ErrorHandler
        errorMessage={<LocalizedText textKey={TextKey.PageNotFoundErrorMessage} />}
        errorTitle={<LocalizedText textKey={TextKey.PageNotFoundTitle} />}
    />
);
